import { BaseTreeModel } from 'app/core/models';

export const ImplantAbutmentBrands: BaseTreeModel[] = [
    {
        id: 1,
        name: 'Straumann',
        children: [
            { id: 1, name: '022.0118S' },
            { id: 2, name: '024.2371' },
            { id: 3, name: '024.4371' },
            { id: 4, name: '064.4374' },
            { id: 5, name: '062.4934' },
            { id: 6, name: '062.4945' },
        ],
    },
    {
        id: 2,
        name: 'Nobel',
        children: [
            { id: 1, name: '38760' },
            { id: 2, name: '36664' },
            { id: 3, name: '38761' },
            { id: 4, name: '38214' },
        ],
    },
    {
        id: 3,
        name: 'Neodent',
        children: [
            { id: 1, name: '118.345' },
            { id: 2, name: '135.357' },
        ],
    },
    { id: 4, name: 'MIS', children: [{ id: 1, name: 'MIS33TC' }] },
    {
        id: 5,
        name: 'Implant Direct',
        children: [
            { id: 1, name: '8735-47' },
            { id: 2, name: 'PYPTC' },
            { id: 3, name: 'TP3HYBN' },
            {
                id: 4,
                name: 'C2242.3808',
            },
            { id: 5, name: 'C2242.4320' },
            { id: 6, name: 'C2242.4308' },
        ],
    },
    {
        id: 6,
        name: 'Truabutment',
        children: [
            { id: 1, name: 'BH45-B13B' },
            { id: 2, name: 'BH45-B13B' },
            { id: 3, name: 'SXR-B13S' },
            {
                id: 4,
                name: 'SXR-B15S',
            },
            { id: 5, name: 'SXW-B13S' },
            { id: 6, name: 'SXW-B15S' },
            { id: 7, name: 'SXR-B13B' },
            {
                id: 8,
                name: 'SXR-B15B',
            },
            { id: 9, name: 'SXW-B13B' },
            { id: 10, name: 'SXW-B15B' },
        ],
    },
    { id: 7, name: 'Zimmer Biomet', children: [{ id: 1, name: 'PFTC41' }] },
];
